export const BASE_BUTTON_PROPS = {
  icon: 'send',
  left: true,
  label: 'Email job to customer',
};

export const MODAL_ID = 'finish-set-up-job-create';
